export type OPTION_VALUE = string | number

export interface OPTION {
  value: OPTION_VALUE,
  label: string,
  children?: OPTION[]
}

export interface IUser {
  id: number,
  name: string,
  avatar: string,
  phone: string,
  email: string,
  checked?: boolean
}

export enum EVerifyPhoneAction {
  SIGNUP_DEV = 'sms_signup_dev', // 申请服务商
  RESET_APPKEY = 'sms_user_reset_app_key', // 重置APPKEY
  VIEW_APPKEY = 'sms_user_view_app_key', // 查看APPKEY
  TRANSFER_SUPER_ADMIN = 'sms_trans_admin', // 转让超管
  DELETE_APP = 'sms_user_delete_app', // 删除应用
  DELETE_CERTIFICATION_WAY = 'sms_user_delete_certification_way', // 删除应用认证方式信息
}
